{
  "version": 1,
  "asset_id": "f841fae2-c746-4f5f-81c6-86815bcbe2b9",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/f841fae2-c746-4f5f-81c6-86815bcbe2b9/clip-img_0012-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/f841fae2-c746-4f5f-81c6-86815bcbe2b9/clip-img_0012-poster-sm.webp",
  "original_filename": "clip-img_0012-poster-sm.webp",
  "size": 16490,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:03Z"
}
